export default __webpack_public_path__ + "static/media/Google.ee97d305.svg";